import React from 'react';
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import { useSession } from '../../contexts/SessionContext';
import { Modal, Button } from '../../components/ui';

const InactivityModal = () => {
  const { showInactivityModal, countdownTime, handleStayLoggedIn } = useSession();

  if (!showInactivityModal) return null;

  const minutes = Math.floor(countdownTime / 60);
  const seconds = countdownTime % 60;

  return (
    <Modal
      isOpen={showInactivityModal}
      // Dismissing by backdrop or Escape counts as "still here", which is
      // what the interaction means — the alternative is silently logging out
      // someone who just pressed Escape.
      onClose={handleStayLoggedIn}
      size="sm"
      title="Still using the app?"
      footer={
        <Button size="lg" fullWidth onClick={handleStayLoggedIn}>
          Yes, I&apos;m still here
        </Button>
      }
    >
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-warning-soft text-warning">
          <AccessTimeOutlined style={{ fontSize: 28 }} aria-hidden="true" />
        </div>

        <p className="text-sm leading-relaxed text-muted-fg">
          You&apos;ve been inactive for a while. For your security, you&apos;ll be signed out if you
          don&apos;t respond.
        </p>

        <div className="mt-5 rounded-lg border border-warning/25 bg-warning-soft p-4">
          <p className="text-xs uppercase tracking-wide text-warning-fg">Signing out in</p>
          {/* aria-live so a screen reader announces the countdown rather than
              the user being logged out with no warning they could perceive. */}
          <p
            className="tabular mt-1 text-4xl font-semibold text-warning-fg"
            role="timer"
            aria-live="polite"
          >
            {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
          </p>
        </div>

        <p className="mt-4 text-xs text-muted-fg">
          Any click or keypress will also keep you signed in.
        </p>
      </div>
    </Modal>
  );
};

export default InactivityModal;
